module.exports = __webpack_public_path__ + "img/Bjornson_kiste.97cca137.jpg";